export default __webpack_public_path__ + "static/media/imgkahshpay_1.5ac14917.png";